import React, { useState } from 'react'
import { Separator, Expander, ExpanderHeader, ExpanderContent } from '@fs/zion-ui'

import styles from './ReprocessFolder.styles'
import transl from './ReprocessFolder.transl'
import ReprocessButton from './ReprocessButton'
import ReprocessChangeHistory from './ReprocessChangeHistory'

export default function ReprocessFolder() {
  const [requested, setRequested] = useState(false)
  const [duplicateRequest, setDuplicateRequest] = useState(false)

  return (
    <div css={styles.reprocessFolder}>
      <Expander>
        <ExpanderHeader>{transl.reprocessFolder()}</ExpanderHeader>
        <ExpanderContent>
          <Separator size="xxs" />
          <ReprocessButton
            requested={requested}
            setRequested={setRequested}
            duplicateRequest={duplicateRequest}
            setDuplicateRequest={setDuplicateRequest}
          />
          <Separator size="xxs" />
          <ReprocessChangeHistory requested={requested} duplicateRequest={duplicateRequest} />
        </ExpanderContent>
      </Expander>
    </div>
  )
}
